/**
 * Artiley 2026-10-23: bakåtknappen tar kunden tillbaka till samma tavla i listor utan sidindelning
 * (kollektioner med högst 48 tavlor, startsidans produktrader). Listor med sidindelning sköts av
 * pagination.js, som också bygger upp de sidor som var inladdade.
 *
 * Webbläsarens egen återställning stängs av (manual) och läget läggs tillbaka här, både när sidan
 * laddas om vid bakåt och när den visas ur back/forward-cachen. Safari på iPhone lägger alltid en sida
 * ur cachen högst upp först och hittar bara tillbaka själv i auto-läget, som har kända fel på
 * Shopify-listor (WebKit bug 273617). Bakgrund: docs/ops/investigations/2026-10-19-bakat-knappen-tappar-platsen-i-listan.md
 *
 * ?scrolldebug=1 på en lista visar en ruta med vad som hände vid bakåt (för test på telefon).
 */
(function () {
  if (window.artileyTillbaka) return;
  window.artileyTillbaka = true;

  var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  felsok();
  manuell();
  if (document.querySelector('pagination-theme')) return;
  var KEY = 'artiley-tillbaka:' + location.pathname + location.search;
  var LADDNING = Date.now() + '-' + Math.random().toString(36).slice(2);
  var klickad = null;
  var senast = null;

  function kortFor(a) {
    return a.closest('.column, .columns, li') || a;
  }
  function kortMed(href) {
    var sett = [];
    document.querySelectorAll('a[href]').forEach(function (a) {
      if (a.getAttribute('href') !== href) return;
      var kort = kortFor(a);
      if (sett.indexOf(kort) === -1) sett.push(kort);
    });
    return sett;
  }
  function spara() {
    var a = klickad && document.contains(klickad) ? klickad : null;
    var data = { y: window.scrollY, id: LADDNING, t: Date.now() };
    if (a) {
      var kort = kortFor(a);
      data.href = a.getAttribute('href');
      data.nr = kortMed(data.href).indexOf(kort);
      data.top = kort.getBoundingClientRect().top;
    }
    senast = data;
    manuell();
    try {
      sessionStorage.setItem(KEY, JSON.stringify(data));
    } catch (e) {}
  }

  // Spara redan vid klicket: Safari skickar inget pagehide om sidan inte hunnit ladda klart.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    klickad = a;
    spara();
  }, true);
  window.addEventListener('pagehide', spara);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') spara();
  });

  function sparat() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY));
    } catch (e) {
      return null;
    }
  }
  function mal(data) {
    if (data.href) {
      var kort = kortMed(data.href);
      var k = kort[data.nr] || kort[0];
      if (k && k.getBoundingClientRect().height) return k.getBoundingClientRect().top + window.scrollY - data.top;
    }
    return data.y || 0;
  }
  function hoppa(y) {
    // Temat har scroll-behavior: smooth på sidan; hoppet ska vara direkt.
    var root = document.documentElement,
      behavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    root.style.scrollBehavior = behavior;
  }
  // Lägg tillbaka och rätta några gånger medan bilder, karuseller och webbläsaren rör sidan. Slutar så
  // fort kunden själv rör skärmen.
  function aterstall(data) {
    if (!data) return;
    var avbruten = false;
    function avbryt() {
      avbruten = true;
    }
    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (t) {
      window.addEventListener(t, avbryt, { once: true, passive: true });
    });
    function steg(alltid) {
      if (avbruten) return;
      var y = mal(data);
      if (alltid || Math.abs(window.scrollY - y) > 2) hoppa(y);
    }
    steg(false);
    // Första rättningen i nästa bildruta scrollar alltid: en scroll direkt i pageshow kan på iPhone
    // stanna inne i sidan utan att nå skärmen, och då visar scrollY rätt fast skärmen står på toppen.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        steg(true);
      });
    });
    [150, 400, 900, 1600].forEach(function (ms) {
      setTimeout(function () {
        steg(false);
      }, ms);
    });
    window.addEventListener('load', function () {
      steg(false);
    }, { once: true });
  }

  if (nav && (nav.type === 'back_forward' || nav.type === 'reload')) aterstall(sparat());
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    // Eget minne först; sessionStorage bara om det sparades under just den här sidvisningen.
    var data = senast;
    if (!data) {
      var s = sparat();
      if (s && s.id === LADDNING) data = s;
    }
    aterstall(data);
  });

  // Webbläsarens egen återställning av. Temats animationer (GSAP ScrollTrigger) sätter tillbaka
  // history.scrollRestoration till värdet de såg när de startade vid varje refresh (bland annat vid
  // load); clearScrollMemory('manual') ger dem manual som utgångsvärde. Körs också vid varje sparning,
  // så att läget är manual när kunden lämnar sidan.
  function manuell() {
    try {
      if (window.ScrollTrigger && ScrollTrigger.clearScrollMemory && !manuell.klar) {
        ScrollTrigger.clearScrollMemory('manual');
        manuell.klar = true;
      }
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    } catch (e) {}
  }

  // Felsökning på telefon: ?scrolldebug=1 visar i ett par sekunder hur sidan kom tillbaka.
  function felsok() {
    var pa = /[?&]scrolldebug=1/.test(location.search);
    try {
      if (pa) sessionStorage.setItem('artiley-scrolldebug', '1');
      pa = pa || sessionStorage.getItem('artiley-scrolldebug') === '1';
    } catch (e) {}
    if (!pa) return;
    function visa(vag) {
      var ruta = document.createElement('div');
      ruta.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;background:#151515;color:#fff;font:12px/1.4 monospace;padding:8px;border-radius:6px;white-space:pre-wrap';
      document.body.appendChild(ruta);
      var rader = [vag + ' · nav=' + (nav ? nav.type : '?') + ' · restoration=' + history.scrollRestoration];
      [0, 300, 1000, 2000].forEach(function (ms) {
        setTimeout(function () {
          rader.push(ms + ' ms: scrollY=' + Math.round(window.scrollY));
          ruta.textContent = rader.join('\n');
        }, ms);
      });
      setTimeout(function () {
        ruta.remove();
      }, 6000);
    }
    window.addEventListener('pageshow', function (e) {
      visa(e.persisted ? 'ur minnet (persisted)' : 'laddad (inte ur minnet)');
    });
  }
})();
